import { all, put, select, takeEvery } from 'redux-saga/effects'
import moment from 'moment'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import {
    blockDataTransformed,
    blockSaveCustomData,
} from '../../../../../../../components/Workspace/components/HocBlock/actions'

import { PAYMENT_COMPARISON_TOGGLE_CHART_DATA_TABLE } from '../../PaymentComparison/components/Chart/constants'
import { getCustomData } from '../../../../../../../../../global/selectors'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.paymentComparison.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(_action, 'data.data', null)

    // TODO: Tell data to flip order of data to remove the reverse
    const transformedData = {
        summary: data?.[0],
        chartData: _.map(data?.[1]?.table, (row) => {
            return {
                ...row,
                date: moment(row?.date?.value).format('DD-MM-YYYY'),
            }
        }),
        empty: data?.[1]?.empty,
    }

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    const customData = {
        showChartDataTable: false,
    }

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

function* onChartDataTableToggleSaga(_action) {
    const blockKey = _.get(_action, 'data.block', null)
    if (blockKey !== config.modules.report.blocks.paymentComparison.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = yield select(getCustomData, module, blockKey, id)
    const showChartDataTable = _.get(_action, 'data.showChartDataTable', false)
    yield put(
        blockSaveCustomData(module, id, blockKey, {
            ...customData,
            showChartDataTable: !showChartDataTable,
        })
    )

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(PAYMENT_COMPARISON_TOGGLE_CHART_DATA_TABLE, onChartDataTableToggleSaga),
    ])
}
